import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";

const LISTADO_CENTROS = 'LISTADO_CENTROS';
const GUARDAR_CENTROS = 'GUARDAR_CENTROS';
const LOADER = 'LOADER';
const MODULO = 'MODULO';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    //const params = { page, id };
    const params = { id };
    api.get('/centro_trabajo', params).then((response)=>{
        dispatch({ type: LISTADO_CENTROS, data: response });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al listar centros de trabajo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const registroCentro = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormCentroTrabajo.values;
    const formData = {
        codigo: data.codigo,
        activo: data.activo === false ? 'False' : 'True',
        descripcion: data.descripcion,
        empresa: id_emp[5]
    }
    dispatch(setLoader(true));
    api.post('/centro_trabajo/', formData).then(() => {
        NotificationManager.success(
        'Centro de trabajo creado',
        'Exito',
        3000
    );
    let ruta = `/produccion/${id_emp[5]}/centro_trabajo`
    dispatch(push(ruta));
    }).catch((error) => {
    NotificationManager.error(
        error.msj,
        'Error',
        2000
    );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const modificarCentro = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const datos = getStore().form.FormCentroTrabajo.values;
    const id = datos.id;
    const formData = {
        id: id,
        codigo: datos.codigo,
        activo: datos.activo === false ? 'False' : 'True',
        descripcion: datos.descripcion
    }
    dispatch(setLoader(true));
    api.put(`/centro_trabajo/${id}/`, formData).then(() => {
        NotificationManager.success(
            'Centro de trabajo modificado correctamente',
            'Exito',
            3000
        );
        let ruta = `/produccion/${id_emp[5]}/centro_trabajo`
        dispatch(push(ruta));
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al modificar centro de trabajo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/centro_trabajo/${id}`).then((response) => {
        dispatch({type: GUARDAR_CENTROS, lectura: response });
        dispatch(initializeForm('FormCentroTrabajo', response ));
    }).catch((error)=>{
        console.log("error: ", error)
        NotificationManager.error(
            'Ocurrió un error al consultar centro de trabajo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch((error) => {
        if (error.status === 401){
            NotificationManager.error(
              error.body.msj,
              'Error',
              0
            );
        }
        if (error.status === 400){
            NotificationManager.error(
              'Ocurrió un error en buscar modulo',
              'Error',
              0
            );
        }
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const actions = {
    listar,
    registroCentro,
    modificarCentro,
    leer,
    getModulo
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO_CENTROS]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [GUARDAR_CENTROS]: (state, { lectura }) => {
        return {
            ...state,
            lectura,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
};

export const initialState = {
    loader: false,
    lectura: [],
    modulo: [],
    data: [],
    page: 1,
};

export default handleActions(reducers, initialState)
 